export const dateTimeFilter = (array, valGetter, filterVal) => {
  if (filterVal === null) {
    return array;
  }
  let left = filterVal.left;
  let right = filterVal.right;
  return array.filter(element => {
    let val = valGetter(element);

    if (left.length > 0) {
      if (val === null || val === undefined) {
        return false;
      }
      if (val < left.substr(0, val.length)) {
        return false;
      }
    }

    if (right.length > 0) {
      if (val === null) {
        return false;
      }
      if (val > right.substr(0, val.length)) {
        return false;
      }
    }

    return true;
  })
};

const textFilter = (array, valGetter, filterVal, comparator) => {
  if (filterVal.length === 0) {
    return array;
  }
  return array.filter(element => {
    let val = valGetter(element) !== null ? valGetter(element).toString() : valGetter(element);
    if (val === null) {
      return false;
    }
    return comparator(val.toLowerCase(), filterVal.toLowerCase().trim());
  })
};

const multiValueDelimiter = '///';

export const includeTextFilter = (array, valGetter, filterVal) => {
  return textFilter(array, valGetter, filterVal, (elementValue, filterValue) => {
    const filterValues = filterValue.split(multiValueDelimiter);
    return filterValues.some((i) => i && elementValue.includes(i));
  });
};

export const equalTextFilter = (array, valGetter, filterVal) => {
  return textFilter(array, valGetter, filterVal, (left, right) => left === right);
};



// WEBPACK FOOTER //
// ./src/common/arrayFilters.js